namespace advisorop.components.servicer {

    export class OrionIntegrationRequestController {

        static $inject = ["generalService", "servicerService"];
        constructor(private generalService: services.GeneralService,
            private servicerService: services.ServicerService) {
        }

        orionLinkRequest(): void {
            this.servicerService.orionIntegrationCheck()
                .then(data => {
                    var proceed: Boolean = true;
                    if (data.data == "ALREADY_LINKED") {
                        proceed = confirm(`It looks like your account is already linked. Link again?`);
                    }
                    if (proceed) {
                        this.servicerService.orionIntegrationRequest()
                            .then(data => {
                                window.open(data.data, "_blank");
                            })
                            .catch(err => { this.generalService.showError(err); });
                    } else {
                        toastr.warning("You have decided not to link at this time.");
                    }
                })
                .catch(err => { toastr.error("Error."); });
        }

        $onInit(): void {

        };

        $onChanges(evt): void {
        }

    }

    class OrionIntegrationRequest implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "router": "<",
            };
            this.controller = OrionIntegrationRequestController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/orion-integration-request.html';
        }
    }
    angular.module(Constants.APP).component("orionIntegrationRequest", new OrionIntegrationRequest());
}